import { render, staticRenderFns } from "./ArchivePDF.vue?vue&type=template&id=284c16f9&"
import script from "./ArchivePDF.vue?vue&type=script&lang=ts&"
export * from "./ArchivePDF.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports